module.exports = __webpack_public_path__ + "files/66dea596982db012fb8ddb272bbb3938.png";